const { h, render, Component } = require('preact');
const GoodsStatus = require('./goods_status')

class Status extends Component {
  constructor(props) {
    super(props);
  }

  getStatusForGoods(){
    let orderStatus = null;
    if (["GOODS_VOUCHER","GOODS_SHIPPING"].indexOf(this.props.orderDetails.DEAL_TYPE) > -1 && this.props.orderDetails.STATE != 'REFUNDED'){
      orderStatus = <GoodsStatus order={this.props.orderDetails}/>
    }
    return orderStatus;
  }

  getStatusForOthers(){
    let orderStatus = null;
    if(lodash.has(this.props.orderDetails, 'status.dateInfo.label')){
      let label = this.props.orderDetails.status.dateInfo.label;
      let value = this.props.orderDetails.status.dateInfo.value;
      orderStatus = (
        <tr>
          <td>{I18n.translate("js.modules.support.status")}</td>
          <td>
            {label} {value}
          </td>
        </tr>
      );
    }
    return orderStatus;
  }

  getStatus(){
    let orderStatus = null;
    if (["GOODS_VOUCHER","GOODS_SHIPPING"].indexOf(this.props.orderDetails.DEAL_TYPE) > -1 && this.props.orderDetails.STATE != 'REFUNDED'){
      orderStatus = this.getStatusForGoods();
    }

    if(orderStatus == null){
      orderStatus = this.getStatusForOthers();
    }

    return orderStatus;
  }

  render() {
    return this.getStatus();
  }
}
module.exports = Status
